// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3W1H8","notes":"Notes_notes__1Hvi4","note":"Notes_note__1PJWm","markdown":"Notes_markdown__2nu7u"};